import { useEffect, useMemo, useRef, useState } from "react";
import useAxios from "../../utils/useAxios";
import { useAppContext } from "../../context/AppContext";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { setCurrentDate } from "../../utils/currencyFormat";

function GiftTab({ donor_id }) {
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [gifts, setGifts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [role, setRole] = useState(null);
  const [users, setUsers] = useState([]); // Fill this via API on mount
  const axiosAPI = useAxios();

  const [uploadRows, setUploadRows] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [addGiftLoading, setAddGiftLoading] = useState(false);
  const [masterGifts, setMasterGifts] = useState([]);
  const [masterOccasions, setMasterOccasions] = useState([]);

  const { state } = useAppContext();
  const { data, loading: donorLoading } = state;

  const [formData, setFormData] = useState({
    item_issued: "",
    occasion: "",
    issuing_date: "",
    user_id: "",
  });

  const fetchDonorGifts = async () => {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/donor/get-gift-by-id/${donor_id}`,
      );
      setGifts(response?.data?.data); // Assuming backend returns { data: [...] }
      //   setError("");
    } catch (err) {
      console.error("Error fetching donor gifts:", err);
      //   setError("Failed to fetch gifts.");
    } finally {
      setLoading(false);
    }
  };

  async function fetchMasterGift() {
    //  setLoading(true); // Start loading
    try {
      const res = await axiosAPI.get(`/api/gifts/get-master-gifts`);
      // console.log("Gifts", res.data);
      setMasterGifts(res?.data?.results);
    } catch (err) {
      console.error("Error fetching gifts:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  async function fetchMasterOccasion() {
    //  setLoading(true); // Start loading
    try {
      const res = await axiosAPI.get(`/api/gifts/get-master-occasions`);
      setMasterOccasions(res?.data?.results);
    } catch (err) {
      console.error("Error fetching occasions:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  useEffect(() => {
    if (donor_id) {
      fetchDonorGifts();
    }
  }, [donor_id]);

  const filteredOptions = useMemo(() => {
    return data
      .filter((user) => {
        const nameMatch = user.full_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const phoneMatch = user.phone_number
          ?.toString()
          .includes(searchTerm.toLowerCase());
        return nameMatch || phoneMatch;
      })
      .slice(0, 50)
      .map((user) => ({
        value: user.id,
        label: `${user.full_name} - ${user.phone_number || ""}`,
      }));
  }, [data, searchTerm]);

  const loadOptions = (inputValue, callback) => {
    setSearchTerm(inputValue);
    callback(filteredOptions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      user_id: donor_id,
      occasion: formData.occasion,
      item_issued: formData.item_issued,
      issuing_date: formData.issuing_date,
    };

    // console.log("Payload ", payload);

    // return

    setAddGiftLoading(true);

    try {
      let response = await axiosAPI.post(`/api/gifts/add-gift`, payload);
      window.notifyMessage("Success", "Gift Added successfully", "success");
      hideModal("newUserModal");
      resetForm();
      setAddGiftLoading(false);
      fetchDonorGifts();
      hideModal("giftModal");
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  useEffect(() => {
    if (formData.user_id) {
      // filteredOptions is your array of options or you can fetch full user info
      const option =
        filteredOptions.find((opt) => opt.value === formData.user_id) || null;
      setSelectedUser(option);
    } else {
      setSelectedUser(null);
    }
  }, [formData.user_id, filteredOptions]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      item_issued: "",
      occasion: "",
      issuing_date: "",
      user_id: "",
    });
  };

  // console.log("Gifts", gifts);

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    setRole(state?.user?.role);
  }, []);

  // Get All Donor Details
  const getDonorDetails = async () => {
    try {
      const response = await axiosAPI.get("/api/donor/get-donor-details");
      setUsers(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getDonorDetails();
    fetchMasterGift();
    fetchMasterOccasion();
  }, [page]);

  useEffect(() => {
    const currentDate = setCurrentDate();
    // console.log("current ",currentDate)
    setFormData((prev) => ({ ...prev, issuing_date: currentDate }));
  }, []);

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);

    console.log("gifts", gifts);

    // Find the Prashdam with this ID and populate the form
    const selectedGift = gifts.find((gift) => gift.id === id);

    console.log("id", id);
    console.log("selected gift", selectedGift);

    if (selectedGift) {
      const selectedUser = users.find(
        (user) => user.id === selectedGift.user_id,
      );

      console.log("Select User", selectedUser);
      setFormData({
        item_issued: selectedGift.item_issued,
        occasion: selectedGift.occasion,
        issuing_date: selectedGift.issuing_date,
        user_id: selectedUser
          ? { value: selectedUser?.id, label: selectedUser?.full_name }
          : null,
      });
    }

    const modal = new window.bootstrap.Modal(
      document.getElementById("giftModal"),
    );
    modal.show();
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    resetForm();
    setUploadRows("");
    // setCurrentUserId(null);
  };

  // Helper functions to manage modal visibility
  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  const openAddModal = () => {
    showModal("giftModal");
  };

  return (
    <div>
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-4">
          {/*  Right Side - Existing Buttons */}
          {role === "admin" && (
            <div className="d-flex gap-2 flex-wrap">
              <button
                type="button"
                className="btn btn-dark btn-round"
                onClick={() => openAddModal()}
              >
                Add Gifts
              </button>
            </div>
          )}
        </div>

        {/* Modal */}

        <div
          className="modal fade "
          id="giftModal"
          tabIndex="-1"
          aria-labelledby="giftModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content border">
              <div className="modal-header">
                <h5 className="modal-title" id="giftModalLabel">
                  {isEditMode ? "Edit Gift" : "Add Gift"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body shadow">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="item_issued" className="form-label">
                      Item Issued
                    </label>

                    <select
                      className="form-select"
                      id="item_issued"
                      name="item_issued"
                      value={formData.item_issued}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select an item --</option>
                      {masterGifts?.map((item) => (
                        <option key={item.id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="occasion" className="form-label">
                      Occasion
                    </label>

                    <select
                      className="form-select"
                      id="occasion"
                      name="occasion"
                      value={formData.occasion}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select an occasion --</option>
                      {masterOccasions?.map((item) => (
                        <option key={item.id} value={item.occasion_name}>
                          {item.occasion_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="issuing_date" className="form-label">
                      Issuing Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      id="issuing_date"
                      name="issuing_date"
                      value={formData.issuing_date}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode ? "Update Gift" : "Add Gift"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Gifts Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3">
                {/* Title */}
                <h4 className="card-title mb-0">All Gifts ({gifts?.length})</h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>full name</th>
                        <th>Donor ID</th>
                        <th>Ocassion</th>
                        <th>ITEM issued</th>
                        {/* <th>Scheme Patronship No. </th> */}
                        <th>issued Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : gifts.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        gifts.map((gifts) => {
                          const formattedDate = new Date(
                            gifts.issuing_date,
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={gifts.id}>
                              <td>{gifts.full_name}</td>
                              <td>{gifts.donor_id}</td>
                              <td>{gifts.occasion}</td>
                              <td>{gifts.item_issued}</td>
                              {/* <td>{gifts.contact_id}</td> */}
                              {/* <td>{gifts.gift_id}</td> */}

                              {/* <td>{truncatedMessage}</td> */}
                              <td>{formattedDate}</td>
                              {/* <td>
                                {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                    onClick={() => openEditModal(gifts.id)}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                )}
                                 <button
                                      className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                      onClick={() => handleDelete(gifts.id)}
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button> 
                                {role === "admin" && (
                                      <button
                                        className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                        onClick={() => handleDelete(gifts.id)}
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    )}
                              </td> */}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <nav aria-label="Page navigation">
              <ul className="pagination flex justify-content-end">
                {/* First Page */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    First
                  </button>
                </li>

                {/* Previous */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Page Number Buttons in chunks */}
                {(() => {
                  const pageNumbers = [];
                  const maxPagesToShow = 5;
                  const startPage =
                    Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow +
                    1;
                  const endPage = Math.min(
                    startPage + maxPagesToShow - 1,
                    totalPages,
                  );

                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <li
                        key={i}
                        className={`page-item ${page === i ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(i)}
                        >
                          {i}
                        </button>
                      </li>,
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page + 1)}
                  >
                    Next
                  </button>
                </li>

                {/* Last Page */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GiftTab;
